import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    collapsedGroupIds: [],
    globallyCollapsed: false,
}

const groupSlice = createSlice({
    name: 'group',
    initialState,
    reducers: {
        setCollapsedGroupsKeys: (state, action) => {
            state.collapsedGroupIds = action.payload
        },
        toggleGroupCollapse: (state, action) => {
            if (state.collapsedGroupIds.includes(action.payload)) {
                state.collapsedGroupIds = state.collapsedGroupIds.filter(id => id !== action.payload)
                state.globallyCollapsed = false
            } else {
                state.collapsedGroupIds.push(action.payload)
            }
        },
        toggleGlobalCollapse: state => {
            state.globallyCollapsed = !state.globallyCollapsed
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const groupActions = groupSlice.actions

export default groupSlice.reducer
